import moment from "moment";

export const programacionInitialValues = {
  id_cultivo: 0,
  id_variedad: 0,
  calibre: "",
  id_tipo_etiqueta: 0,
  id_peso_envase: 0,
  id_tipo_caja: 0,
  id_etiqueta: 0,
  id_bultos: 0,
  bultos: 0,
  cantidad: 0,
  id_yeguere: 8, // 8 pruebas y prod
  id_destino: 1, // 1 pruebas y prod
  tipo: "Exacto",
  id_destino_inmediato: 4, // 4 pruebas y prod
  id_tarima: 1,
  fumigar: false,
  prioridad: false,
  observaciones: "",
  fecha: moment().format("YYYY-MM-DD"),
  color: 0,
};
